import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import TransferExitInformation from './TransferExitInformation';
import _ from 'lodash';

// this component is used for transfers.
function Counters(props){
    const [transferInfo, transferTicket] = useState('default');
    
    // Use useSelector hooks to access Redux state
    const services = useSelector(state => state.services.services);
    const users = useSelector(state => state.users.users);
    const sessions = useSelector(state => state.sessions.sessions);
    const supportDesks = useSelector(state => state.services.supportDesks);
    
    // get online supportDesks from the online sessions
    const sessionsClone = sessions && Array.isArray(sessions) ? _.cloneDeep(sessions) : [];
    const userIds = users && Array.isArray(users) ? users.map(a => a?.id).filter(Boolean) : [];
    const validSessions = sessionsClone.filter(a => a && userIds.includes(a.userId));
    
    let onlineCounters = [];
    if (validSessions && Array.isArray(validSessions) && supportDesks && Array.isArray(supportDesks)) {
        onlineCounters = validSessions
            .filter(session => session && session.status === 1) 
            .map(session => {
                if (!session || !session.supportDeskId) return null;
                return supportDesks.find(supportDesk => 
                    supportDesk && supportDesk.id === session.supportDeskId
                );
            })
            .filter(Boolean); // Remove null/undefined values
    }
    
    // add all supportDesks to offlineCounters and filter out the onlineCounters
    let offlineCounters = [];
    if (supportDesks && Array.isArray(supportDesks) && onlineCounters && Array.isArray(onlineCounters)) {
        offlineCounters = supportDesks
            .map(supportDesk => {
                if (!supportDesk) return null;
                const isOnline = onlineCounters
                    .filter(onlineCounter => onlineCounter && onlineCounter.id === supportDesk.id).length > 0;
                return isOnline ? null : supportDesk;
            })
            .filter(Boolean); // Remove null values
    }

    // Safe access to transferInfo properties
    const transferCase = transferInfo && typeof transferInfo === 'object' ? transferInfo.case : 'default';

    switch (transferCase){
        case 'exit':
            return (
                <div className="home-right-content1">
                    <div className="titleBlock icon withBackBtn">
                        <div className="iconWrapper" onClick={ () => transferTicket({case: 'default' }) }>
                            <ion-icon name="arrow-back-outline"></ion-icon>
                        </div>
                        <h5>Transfer to Counter</h5>
                        <h5>Back</h5>
                    </div>
                    <TransferExitInformation transferInfo={transferInfo} returnFunction={transferTicket} />
                </div>
            );

        default:
            return(
                <div className="home-left-content5-wraper">
                    <ReactTooltip />
                    <div className="titleBlock icon withBackBtn">
                        <div className="iconWrapper" onClick={ () => props.returnFunction && typeof props.returnFunction === 'function' ? props.returnFunction('default') : null}>
                            <ion-icon name="arrow-back-outline"></ion-icon>
                        </div>
                        <h5>{onlineCounters.length} Counter{ onlineCounters.length !== 1 ? 's' : '' } Online</h5>
                        <h5>Back</h5>
                    </div>
                    <div className="usersListContainer">
                        <div className="user-list-online">
                        {onlineCounters && onlineCounters.map((data, index) => {
                            if (!data) return null;
                            
                            // Safely determine initials
                            let inititals = "";
                            try {
                                if (data.number != null) {
                                    inititals = String(data.number).length ? String(data.number) : (data.type ? data.type.charAt(0) : "");
                                } else if (data.type) {
                                    inititals = data.type.charAt(0);
                                }
                            } catch (e) {
                                inititals = "";
                            }
                            
                            // Safely get support desk services
                            let supportDeskServices = [];
                            try {
                                if (validSessions && Array.isArray(validSessions) && users && Array.isArray(users)) {
                                    const filteredSessions = validSessions.filter(session => 
                                        session && session.supportDeskId === data.id
                                    );
                                    
                                    if (filteredSessions.length > 0) {
                                        const firstSession = filteredSessions[0];
                                        if (firstSession && firstSession.userId) {
                                            const agent = users.find(agent => agent && agent.id === firstSession.userId);
                                            if (agent && agent.services && Array.isArray(agent.services)) {
                                                supportDeskServices = agent.services;
                                            }
                                        }
                                    }
                                }
                            } catch (e) {
                                supportDeskServices = [];
                            }
                            
                            // Generate tooltip content safely
                            let toolTipServices = '';
                            if (supportDeskServices && Array.isArray(supportDeskServices) && services && Array.isArray(services)) {
                                supportDeskServices.forEach(serviceId => {
                                    if (!serviceId) return;
                                    const service = services.find(service => service && service.id === serviceId);
                                    if (service && service.name) {
                                        toolTipServices += '<p style="padding:0;margin:0">' + service.name + '</p>';
                                    }
                                });
                            }
                            
                            return(
                                <div className="user-list" key={index} onClick={ () => transferTicket({ case: 'exit', type:'supportDesk', id: data.id }) }>
                                    <div className="user-name-and-pic">
                                        <div>
                                            <div>
                                                <span className="status-badge"></span>
                                                <span className="user-image-text">{ inititals }</span> 
                                            </div>
                                            <p style={{width:'auto'}}>{ data.type || "" } { data.number != null ? data.number : "" }</p>
                                        </div>
                                    </div>
                                    <div className="user-list-content">
                                        <p data-tip={ toolTipServices } data-html={true}>
                                            { supportDeskServices.length } Service{ supportDeskServices.length !== 1 ? 's' : '' } available here
                                        </p>
                                    </div>
                                    <div className="user-list-check"><ion-icon name="checkmark-circle-outline"></ion-icon></div>
                                </div>
                            );
                        })}
                        </div>

                        <div className="user-list-offline">
                        {offlineCounters && offlineCounters.map((data, index) => {
                            if (!data) return null;
                            
                            // Safely determine initials
                            let inititals = "";
                            try {
                                if (data.number != null) {
                                    inititals = String(data.number);
                                } else if (data.type) {
                                    inititals = data.type.charAt(0);
                                }
                            } catch (e) {
                                inititals = "";
                            }

                            return(
                                <div className="user-list" key={index} onClick={ () => transferTicket({ case: 'exit', type:'supportDesk', id: data.id }) }>
                                    <div className="user-name-and-pic">
                                        <div>
                                            <div>
                                                <span className="status-badge"></span>
                                                <span className="user-image-text">{ inititals }</span> 
                                            </div>
                                            <p>{ data.type || "" } { data.number != null ? data.number : "" }</p>
                                        </div>
                                    </div>
                                    <div className="user-list-content"><p>No Agent Present</p></div>
                                    <div className="user-list-check"><ion-icon name="checkmark-circle-outline"></ion-icon></div>
                                </div>
                            );
                        })}
                        </div>
                    </div>
                </div>
            );
    }
}

export default Counters;